import React from 'react';
import { Box, Chip, Typography } from '@mui/material';

const TOPIC_CHIP_SX = {
  height: 32,
  borderRadius: '999px',
  bgcolor: '#FCE8E8',
  color: '#BE123C',
  fontWeight: 500,
  fontSize: '0.875rem',
};

const ConfirmationEventTopicsSection = ({ topics = [] }) => {
  const selectedTopics = Array.isArray(topics) ? topics : [];

  return (
    <Box sx={{ mt: 2.5, mb: 2.5 }}>
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: '0.9375rem',
          color: 'text.primary',
          mb: 1.25,
        }}
      >
        Event Tags
      </Typography>

      {selectedTopics.length > 0 ? (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1 }}>
          {selectedTopics.map((topic) => (
            <Chip key={topic} label={topic} sx={TOPIC_CHIP_SX} />
          ))}
        </Box>
      ) : (
        <Typography sx={{ fontSize: '0.875rem', fontWeight: 600, color: 'text.primary', mb: 1 }}>
          —
        </Typography>
      )}

      <Typography
        sx={{
          fontSize: '0.8125rem',
          color: 'text.secondary',
          lineHeight: 1.45,
        }}
      >
        These topics will be used for event discovery and attendee recommendations.
      </Typography>
    </Box>
  );
};

export default ConfirmationEventTopicsSection;
